import type { ClientBillingMode, CustomerInvoice, CustomerPayment } from '@logistech/ui-shared';

export const BILLING_MODE_LABELS: Record<ClientBillingMode, string> = {
  PER_TONNE: 'À la tonne livrée',
  PER_KM: 'Au kilomètre',
  FLAT: 'Forfait par trajet',
  PER_TONNE_KM: 'À la tonne × km',
};

/** Unité du prix selon le mode (affichage « 150 000 GNF / t ») */
export const BILLING_RATE_UNIT: Record<ClientBillingMode, string> = {
  PER_TONNE: 't',
  PER_KM: 'km',
  FLAT: 'trajet',
  PER_TONNE_KM: 't·km',
};

export const INVOICE_STATUS_LABELS: Record<CustomerInvoice['status'], string> = {
  DRAFT: 'Brouillon',
  ISSUED: 'Émise',
  PARTIALLY_PAID: 'Payée partiellement',
  PAID: 'Payée',
  CANCELLED: 'Annulée',
};

export const invoiceBadge = (inv: Pick<CustomerInvoice, 'status' | 'overdue'>) => {
  if (inv.overdue) return { label: 'En retard', variant: 'destructive' as const };
  const variant = {
    DRAFT: 'secondary', ISSUED: 'default', PARTIALLY_PAID: 'warning', PAID: 'success', CANCELLED: 'secondary',
  } as const;
  return { label: INVOICE_STATUS_LABELS[inv.status], variant: variant[inv.status] };
};

export const PAYMENT_METHOD_LABELS: Record<CustomerPayment['method'], string> = {
  CASH: 'Espèces',
  BANK_TRANSFER: 'Virement',
  MOBILE_MONEY: 'Mobile money',
  CHECK: 'Chèque',
};

export const gnf = (n: number, cur = 'GNF') => `${Math.round(n).toLocaleString('fr-FR')} ${cur}`;

/** Colonnes « date » de l'API (minuit UTC) : affichage sans décalage de fuseau */
export const dayFr = (d: string | null) => (d ? d.slice(0, 10).split('-').reverse().join('/') : '—');
